import React, {Component} from "react";
import {Modal, Header, Button, Icon, Form} from "semantic-ui-react";
import PropTypes from "prop-types";

export class KycDocumentEditDialog extends Component {
  state = {
    documentId: this.props.identifier,
    description: this.props.description
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.identifier !== prevProps.identifier) this.setState({
      documentId: this.props.identifier,
      description: this.props.description
    });
  }

  handleChange = (e, {name, value}) => { this.setState({[name]: value})}

  render = () => {
    const { description} = this.state;

    return (
      <Modal open={this.props.open}>
        <Header icon={'edit outline'} color={'blue'} content={'Edit KYC Document Metadata'}/>
        <Modal.Content>
          <Form id={'kyc-document-edit-form'} size='large'>
            <Form.Input
              name={'description'}
              label={'Description'}
              value={description}
              onChange={this.handleChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button name={'noBtn'} color='red' inverted onClick={this.props.onNoClick}>
            <Icon name='cancel'/> Cancel
          </Button>
          <Button name={'yesBtn'} color='green' inverted onClick={() => this.props.onYesClick(this.state)}>
            <Icon name='checkmark'/> OK
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

};

KycDocumentEditDialog.propTypes = {
  open: PropTypes.bool,
  identifier: PropTypes.string,
  description: PropTypes.string,
  onYesClick: PropTypes.func,
  onNoClick: PropTypes.func
};